import { useRef } from 'react';
import { SwitchTransition, Transition } from 'react-transition-group';
import styles from './BigTitles.module.scss';

function splitText(text) {
	return text
		.replace(/ /g, '\u00a0')
		.split('')
		.map((letter, i) => (
			<span
				key={i}
				className={styles.letter}
				style={{ transitionDelay: i * 20 + 'ms' }}
			>
				{letter}
			</span>
		));
}

function BigTitles({ activeTitle, videoEnded, hidden }) {
	const title = useRef();

	return (
		<SwitchTransition mode="out-in">
			<Transition appear timeout={1000} nodeRef={title} key={activeTitle.end}>
				{(state) => (
					<h1
						ref={title}
						className={[
							styles.title,
							styles[state],
							videoEnded && styles.last,
							hidden && !videoEnded && styles.hidden,
						]
							.filter(Boolean)
							.join(' ')}
					>
						{activeTitle.title.map((title, i) => (
							<span key={i} className={styles.line}>
								{splitText(title)}
							</span>
						))}
						{activeTitle.subtitle && (
							<span className={styles.small}>
								{splitText(activeTitle.subtitle)}
							</span>
						)}
					</h1>
				)}
			</Transition>
		</SwitchTransition>
	);
}

export default BigTitles;
